/**
 * index.js
 * Written by: Alex Kasemir
 * Combines all of the actions contained in this directory
 */
import * as get from './getResult';
import * as select from './selectResult';
import * as getPlayedAnswer from './getPlayedAnswer';
import * as hideModal from './hideModal';
import * as clearResults from './clearResults';

export default {
  ...get,
  ...select,
  ...getPlayedAnswer,
  ...hideModal,
  ...clearResults,
};
